import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=f08e0372&lang=pug"
import script from "./Jitsi.vue?vue&type=script&lang=js"
export * from "./Jitsi.vue?vue&type=script&lang=js"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=f08e0372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports